module.exports = __webpack_public_path__ + "img/41exp.cc7eb869.jpg";